export default {
    methods: {
        formatterCapitalize(row, column, value, index) {
            return this.$options.filters.capitalize(value);
        },
        formatterMonthYear(row, column, value, index) {
            return this.$options.filters.month_year(value);
        },
    },
};
